module.exports = __webpack_public_path__ + "static/img/rechargecard_bg.7c4c08a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rechargecard_bg.png
// module id = JaiE
// module chunks = 0